import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { callApi } from '../ApiHelper/ApiHelper';
import { apiUrl } from '../ApiHelper/ApiUrl';

export default function useMeta(type) {
    const [meta, setMeta] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!type) return;

        setLoading(true);
        setError(null);

        callApi(`${apiUrl.get_meta}type=${type}`)
            .then((response) => {
                if (response?.status) {
                    setMeta(response?.data?.[0]?.meta); // Assuming `response.data` contains meta
                } else {
                    toast.error('Failed to fetch meta data');
                }
            })
            .catch((err) => {
                toast.error(err.message || 'Something went wrong');
            })
            .finally(() => {
                setLoading(false);
            });

    }, [type]);

    return { meta, loading };
}
